import { useState, useEffect } from "react";
import { Heart, Eye, EyeOff, ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import Select from "react-select";
import { State, City } from "country-state-city";
import { Languages } from "lucide-react"; // Import ArrowLeft icon
import {
  Select as ShadSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { Separator } from "./ui/separator";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import {
  BASE_URL,
  getWithoutTokenAPI,
  postWithoutTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setBasic_ID } from "../redux/basic_idSlice";
import { setbasicId } from "../redux/userSlice";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import NotFoundPage from "./404page";

export function RegisterPage({ onNavigate, usrid }) {
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const data = useSelector((state) => state.user);
  console.log(data, "data-----");
  const userid = data?.userId?.user?._id;
  console.log("userid", userid);
  const token = data?.userId?.accessToken;
  const dispatch = useDispatch();
  const [header, setHeader] = useState(null);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const { verifiedUser } = location.state || {};

  const [formData, setFormData] = useState({
    user_id: "",
    name: "",
    dob: "",
    age: "",
    gender: "",
    maritalStatus: "",
    caste: "",
    religion: "",
    district: "",
    state: "",
    child_count: "",
  });

  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); // get all Indian states
    setStatesList(states); // store whole object
  }, []);

  const statesOptions = statesList.map((s) => ({
    value: s.name,
    label: s.name,
    isoCode: s.isoCode, // important!
  }));

  const districtsOptions = districtList.map((d) => ({
    value: d,
    label: d,
  }));

  const [currentLang, setCurrentLang] = useState("en");

  const changeLanguage = () => {
    const newLang = currentLang === "en" ? "ta" : "en";
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  const handleStateChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedState("");
      setDistrictList([]);
      handleFieldChange("state", "");
      return;
    }

    setSelectedState(selectedOption.value);
    handleFieldChange("state", selectedOption.value);

    const state = statesList.find((item) => item.name === selectedOption.value);

    if (state) {
      const cities = City.getCitiesOfState("IN", state.isoCode);
      setDistrictList(cities.map((c) => c.name));
    }
  };

  const religionList = [
    "Hindu",
    "Christian",
    "Muslim",
    "Buddhist",
    "Jain",
    "Sikh",
    "Prefer not to say",
  ];

  const age = new Date().getFullYear() - new Date(formData.dob).getFullYear();

  const validatebasicForm = (formData) => {
    const errors = {};
    // ✅ Basic Name
    if (!formData.name || formData.name.trim() === "") {
      errors.name = t("Full name is required");
    } else if (formData.name.trim().length < 3) {
      errors.name = t("Full name must be at least 3 characters");
    }

    // ✅ Basic Gender
    if (!formData.gender) {
      errors.gender = t("Gender is required");
    }

    // ✅ Basic DOB
    if (!formData.dob) {
      errors.dob = t("Date of birth is required");
    } else if (age < 18 || age > 60) {
      errors.age = t("Age must be greater than 18");
    }

    // ✅ Basic Marital Status
    if (!formData.maritalStatus) {
      errors.maritalStatus = t("Marital status is required");
    }
    // ✅ Religion
    if (!formData.religion || formData.religion.trim() === "") {
      errors.religion = t("Religion is required");
    }
    // ✅ Caste
    if (!formData.caste) {
      errors.caste = t("Caste is required");
    }

    // ✅ Basic Location Fields
    if (!formData.district || formData.district.trim() === "") {
      errors.district = t("District is required");
    }

    // ✅ Basic Location Fields
    if (!formData.state || formData.state.trim() === "") {
      errors.state = t("State is required");
    }

    if (formData.child_count) {
      const childrenNum = parseInt(formData.child_count);
      if (isNaN(childrenNum) || childrenNum < 0 || childrenNum > 10) {
        errors.child_count = t("Please enter a number between 0 and 10");
      }
    }
    return errors;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };

  // Clear errors when user starts typing
  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    // Clear error for this specific field when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const basicSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const newErrors = validatebasicForm(formData);
    setErrors(newErrors);

    console.log(newErrors , "err========")
    if (Object.keys(newErrors).length > 0) {
      return; // stop submission if validation fails
    }

    try {
      const payload = {
        user_id: userid,
        name: capitalize(formData.name),
        gender: formData.gender,
        dob: formatDate(formData.dob),
        age: age,
        maritalStatus: formData.maritalStatus,
        religion: capitalize(formData.religion),
        caste: formData.caste,
        state: capitalize(formData.state),
        district: capitalize(formData.district),
        child_count: formData.child_count,
      };
      console.log("payload", payload);
      const response = await postWithTokenAPI(
        token,
        "/basic-profile/create",
        payload
      );
      console.log("response", response.data._id);
      if (response?.statusCode == 200) {
        console.log("profile creation done");
        toast.success(`${t("Profile Creation Successful")}`);
        navigate("/");
      }
    } catch (error) {
      console.error("Error creating profile:", error);
      toast.error(`${t("ProfileData not Saved")}`);
    }
  };
  const handleBack = () => {
    navigate(-1); // Go back to previous page
    // Or you can use: navigate('/') to go to home page
  };

  // if (verifiedUser) {

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-50">
      <Toaster position="top-right" />
      <div className="bg-white shadow-sm border-b border-border">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="flex justify-between items-center h-16">
            <button
              onClick={() => { navigate('/login') }}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-medium">{t("Back")}</span>
            </button>

            <div className="w-20"></div>
          </div> */}
          <div className="flex justify-between items-center h-16">
            {/* Back Button on Left End */}
            <button
              onClick={() => {
                navigate("/");
              }}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-medium">{t("Back")}</span>
            </button>

            <div className="w-20">
              <Button
                variant="ghost"
                size="sm"
                onClick={changeLanguage}
                className="avan-avala-language-btn hidden md:flex items-center space-x-1 text-gray-600 cursor-pointer hover:text-orange-500"
              >
                <Languages className="w-4 h-4" />
                <span className="avan-avala-language-text text-sm font-medium">
                  {currentLang === "en" ? "தமிழ்" : "English"}
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl w-full left-bg">
          {/* Left side - Image */}
          <div className="hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[700px]">
              <ImageWithFallback
                src="/Images/authentic-indian-bride-groom.jpg"
                alt="Happy couple"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-8 left-8 text-white">
                <h2 className="text-2xl mb-2">{t("Start Your Journey")}</h2>
                <p className="text-white/90">
                  {t(
                    "Join thousands who found their perfect match through SoulMate"
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Right side - Form */}
          <div className="flex items-center justify-center">
            <Card
              className="w-full max-w-md h-fit max-h-[75vh] overflow-y-fixed"
              style={{ border: "none" }}
            >
              <CardHeader className="text-center">
                <CardTitle className="text-2xl">
                  {t("Create Account")}
                </CardTitle>
                <p className="text-muted-foreground">
                  {t("Basic Information")}
                </p>

                <div className="w-full bg-muted rounded-full h-2 mt-4">
                  <div
                    className="bg-gradient-to-br from-red-500 to-pink-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${(1 / 2) * 100}%` }}
                  />
                </div>
              </CardHeader>

              <CardContent className="space-y-4">
                <form onSubmit={basicSubmit} className="space-y-4">
                  {/* Full Name */}
                  <div className="space-y-2">
                    <Label
                      htmlFor="name"
                      className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                    >
                      {t("Full name")}
                      <span className="text-red-500">*</span>
                    </Label>
                    <Input
                      id="name"
                      type="text"
                      value={formData.name}
                      placeholder={t("Enter your full name")}
                      onChange={(e) =>
                        handleFieldChange("name", e.target.value)
                      }
                      className={`
        h-10 rounded-l border border-gray-300 bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 placeholder:text-gray-400
        ${
          errors.name
            ? "border-red-500 ring-2 ring-red-200"
            : "hover:border-gray-400"
        }
      `}
                    />
                    {submitted && errors.name && (
                      <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                        {errors.name}
                      </p>
                    )}
                  </div>

                  {/* Date of Birth & Age */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label
                        htmlFor="dob"
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {t("Date of Birth")}
                        <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        id="dob"
                        type="date"
                        value={formData.dob}
                        onChange={(e) =>
                          handleFieldChange("dob", e.target.value)
                        }
                        className={`
          h-10 rounded-l border border-gray-300 bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200
          ${
            errors.dob
              ? "border-red-500 ring-2 ring-red-200"
              : "hover:border-gray-400"
          }
        `}
                      />
                      {submitted && errors.dob && (
                        <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                          {errors.dob}
                        </p>
                      )}
                    </div>

                    <div className="space-y-2">
                      <Label
                        htmlFor="age"
                        className="text-sm font-semibold text-gray-700"
                      >
                        {t("Age")}
                      </Label>
                      <Input
                        id="age"
                        type="number"
                        placeholder={t("Auto calculated")}
                        value={age}
                        readOnly
                        className="h-10 rounded-l border border-gray-300 bg-gray-50 text-gray-500 cursor-not-allowed"
                      />
                    </div>
                  </div>

                  {/* Gender */}
                  <div className="space-y-2">
                    <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                      {t("Gender")}
                      <span className="text-red-500">*</span>
                    </Label>
                    <ShadSelect
                      value={formData.gender || ""}
                      onValueChange={(value) =>
                        handleFieldChange("gender", value)
                      }
                    >
                      <SelectTrigger
                        className={`
          h-10 rounded-l border bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200
          ${
            errors.gender
              ? "border-red-500 ring-2 ring-red-200"
              : "border-gray-300 hover:border-gray-400"
          }
        `}
                      >
                        <SelectValue placeholder={t("Select gender")} />
                      </SelectTrigger>
                      <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                        <SelectItem value="Male" className="rounded-lg">
                          {t("Male")}
                        </SelectItem>
                        <SelectItem value="Female" className="rounded-lg">
                          {t("Female")}
                        </SelectItem>
                        <SelectItem value="Other" className="rounded-lg">
                          {t("Other")}
                        </SelectItem>
                      </SelectContent>
                    </ShadSelect>
                    {submitted && errors.gender && (
                      <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                        {errors.gender}
                      </p>
                    )}
                  </div>

                  {/* Religion & Caste */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Religion */}
                    <div className="space-y-2">
                      <Label className="text-sm font-semibold text-gray-700">
                        {t("Religion")}
                      </Label>
                      <Select
                        value={
                          formData.religion
                            ? {
                                value: formData.religion,
                                label: formData.religion,
                              }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleFieldChange(
                            "religion",
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        options={religionList.map((religion) => ({
                          value: religion,
                          label: t(religion),
                        }))}
                        placeholder={t("Select Religion ")}
                        isClearable
                        className="react-select-container"
                        classNamePrefix="react-select"
                        classNames={{
                          control: (state) => `
            h-10 rounded-l border bg-white transition-all duration-200 text-sm
            ${
              state.isFocused
                ? "border-red-500 ring-2 ring-red-200"
                : "border-gray-300 hover:border-gray-400"
            }
            ${errors.religion ? "border-red-500 ring-2 ring-red-200" : ""}
          `,
                          option: (state) => `
            text-sm px-3 py-2 cursor-pointer
            ${
              state.isSelected
                ? "bg-red-500 text-white"
                : state.isFocused
                ? "bg-red-50 text-red-700"
                : "text-gray-900"
            }
          `,
                          menu: () =>
                            "rounded-l border border-gray-200 shadow-lg mt-1",
                          menuList: () => "py-1",
                          placeholder: () => "text-gray-400",
                          singleValue: () => "text-gray-900",
                          indicatorSeparator: () => "bg-gray-300",
                          dropdownIndicator: () =>
                            "text-gray-400 hover:text-gray-600",
                          clearIndicator: () =>
                            "text-gray-400 hover:text-gray-600",
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "31px",
                            height: "31px",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            boxShadow: "none",
                            justifyContent: "center",
                            alignItems: "center",
                            "&:hover": {
                              borderColor: "#9ca3af",
                            },
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "31px",
                            padding: "0 12px",
                          }),
                          input: (base) => ({
                            ...base,
                            margin: "0",
                            padding: "0",
                            color: "#1f2937",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "31px",
                          }),
                        option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#626161ff"
                              : state.isFocused
                              ? "#dfdfdfff"
                              : "white",
                            color: state.isSelected
                              ? "white"
                              : state.isFocused
                              ? "#000000ff"
                              : "#6b6b6bff",
                            "&:active": {
                              backgroundColor: state.isSelected
                                ? "#515151ff"
                                : "#d9d9d9ff",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: "12px",
                            border: "1px solid #e5e7eb",
                            boxShadow:
                              "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                            overflow: "hidden",
                          }),
                        }}
                      />
                      {submitted && errors.religion && (
                        <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                          {errors.religion}
                        </p>
                      )}
                    </div>

                    {/* Caste */}
                    <div className="space-y-2">
                      <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                        {t("Caste")}
                        <span className="text-red-500">*</span>
                      </Label>
                      <ShadSelect
                        value={formData.caste || ""}
                        onValueChange={(value) =>
                          handleFieldChange("caste", value)
                        }
                      >
                        <SelectTrigger
                          className={`
            h-10 rounded-l border bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200
            ${
              errors.caste
                ? "border-red-500 ring-2 ring-red-200"
                : "border-gray-300 hover:border-gray-400"
            }
          `}
                        >
                          <SelectValue placeholder={t("Select caste")} />
                        </SelectTrigger>
                        <SelectContent className="rounded-l border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
                          {[
                            "Nadar",
                            "Pillai",
                            "Naidu",
                            "Ilathu Pillai",
                            "Vishwakarma",
                            "Saiva Pillai",
                            "Kallar",
                            "Maravar",
                            "Agamudaiyar",
                            "Chettiyar",
                            "Christian",
                            "Muslim",
                            "Maruthuvar",
                            "Sourashtra",
                            "Vanniyar",
                            "Naicker",
                            "Muppanar",
                            "Veerasaivam",
                            "Malayali",
                            "Kulalar",
                            "Iyer",
                            "Iyengar",
                            "Mudaliyar",
                            "Yadavar",
                            "Reddy",
                            "Vannar",
                            "Doctor",
                            "Adi Dravidar",
                            "Devendra Kula Vellalar",
                            "Arunthathiyar",
                            "Kolandar",
                            "No Caste Barrier",
                          ].map((caste) => (
                            <SelectItem
                              key={caste}
                              value={caste}
                              className="rounded-lg"
                            >
                              {caste=='No Caste Barrier'? t('Prefer not to say'):t(caste)}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </ShadSelect>
                      {submitted && errors.caste && (
                        <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                          {errors.caste}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* State */}
                  <div className="space-y-2">
                    <Label className="text-sm font-semibold text-gray-700">
                      {t("State")}
                    </Label>
                    <Select
                      value={
                        selectedState
                          ? { value: selectedState, label: selectedState }
                          : null
                      }
                      onChange={handleStateChange}
                      options={statesOptions}
                      placeholder={t("Select State")}
                      isClearable
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) => `
          h-10 rounded-l border bg-white transition-all duration-200 text-sm
          ${
            state.isFocused
              ? "border-red-500 ring-2 ring-red-200"
              : "border-gray-300 hover:border-gray-400"
          }
        `,
                        option: (state) => `
          text-sm px-3 py-2 cursor-pointer
          ${
            state.isSelected
              ? "bg-red-500 text-white"
              : state.isFocused
              ? "bg-red-50 text-red-700"
              : "text-gray-900"
          }
        `,
                        menu: () =>
                          "rounded-l border border-gray-200 shadow-lg mt-1",
                        menuList: () => "py-1",
                        placeholder: () => "text-gray-400",
                        singleValue: () => "text-gray-900",
                        indicatorSeparator: () => "bg-gray-300",
                        dropdownIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                        clearIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "31px",
                          height: "31px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "none",
                          "&:hover": {
                            borderColor: "#9ca3af",
                          },
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "31px",
                          padding: "0 12px",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: "0",
                          padding: "0",
                          color: "#1f2937",
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          height: "31px",
                        }),
                       option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#626161ff"
                              : state.isFocused
                              ? "#dfdfdfff"
                              : "white",
                            color: state.isSelected
                              ? "white"
                              : state.isFocused
                              ? "#000000ff"
                              : "#6b6b6bff",
                            "&:active": {
                              backgroundColor: state.isSelected
                                ? "#515151ff"
                                : "#d9d9d9ff",
                            },
                          }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: "12px",
                          border: "1px solid #e5e7eb",
                          boxShadow:
                            "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                          overflow: "hidden",
                        }),
                      }}
                    />
                    {submitted && errors.state && (
                      <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                        {errors.state}
                      </p>
                    )}
                  </div>

                  {/* District */}
                  <div className="space-y-2">
                    <Label className="text-sm font-semibold text-gray-700">
                      {t("District")}
                    </Label>
                    <Select
                      value={
                        formData.district
                          ? {
                              value: formData.district,
                              label: formData.district,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleFieldChange(
                          "district",
                          selectedOption ? selectedOption.value : ""
                        )
                      }
                      options={districtsOptions}
                      placeholder={t("Select District")}
                      isClearable
                      isDisabled={!selectedState}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      classNames={{
                        control: (state) => `
          h-10 rounded-l border bg-white transition-all duration-200 text-sm
          ${
            state.isFocused
              ? "border-red-500 ring-2 ring-red-200"
              : "border-gray-300 hover:border-gray-400"
          }
          ${!selectedState ? "bg-gray-50 cursor-not-allowed" : ""}
        `,
                        option: (state) => `
          text-sm px-3 py-2 cursor-pointer
          ${
            state.isSelected
              ? "bg-red-500 text-white"
              : state.isFocused
              ? "bg-red-50 text-red-700"
              : "text-gray-900"
          }
        `,
                        menu: () =>
                          "rounded-l border border-gray-200 shadow-lg mt-1",
                        menuList: () => "py-1",
                        placeholder: () => "text-gray-400",
                        singleValue: () => "text-gray-900",
                        indicatorSeparator: () => "bg-gray-300",
                        dropdownIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                        clearIndicator: () =>
                          "text-gray-400 hover:text-gray-600",
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "31px",
                          height: "31px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          boxShadow: "none",
                          backgroundColor: !selectedState ? "#f9fafb" : "white",
                          "&:hover": {
                            borderColor: !selectedState ? "#d1d5db" : "#9ca3af",
                          },
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "31px",
                          padding: "0 12px",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: "0",
                          padding: "0",
                          color: "#1f2937",
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          height: "31px",
                        }),
                       option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#626161ff"
                              : state.isFocused
                              ? "#dfdfdfff"
                              : "white",
                            color: state.isSelected
                              ? "white"
                              : state.isFocused
                              ? "#000000ff"
                              : "#6b6b6bff",
                            "&:active": {
                              backgroundColor: state.isSelected
                                ? "#515151ff"
                                : "#d9d9d9ff",
                            },
                          }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: "12px",
                          border: "1px solid #e5e7eb",
                          boxShadow:
                            "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                          overflow: "hidden",
                        }),
                      }}
                    />
                    {submitted && errors.district && (
                      <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                        {errors.district}
                      </p>
                    )}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                        {t("Marital Status")}
                        <span className="text-red-500">*</span>
                      </Label>
                      <ShadSelect
                        value={formData.maritalStatus || ""}
                        onValueChange={(value) =>
                          handleFieldChange("maritalStatus", value)
                        }
                      >
                        <SelectTrigger
                          className={`
        h-10 rounded-l border bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200
        ${
          errors.maritalStatus
            ? "border-red-500 ring-2 ring-red-200"
            : "border-gray-300 hover:border-gray-400"
        }
      `}
                        >
                          <SelectValue
                            placeholder={t("Select Marital Status")}
                          />
                        </SelectTrigger>
                        <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                          <SelectItem value="Single" className="rounded-lg">
                            {t("Single")}
                          </SelectItem>
                          <SelectItem value="Divorced" className="rounded-lg">
                            {t("Divorced")}
                          </SelectItem>
                          <SelectItem value="Widowed" className="rounded-lg">
                            {t("Widowed")}
                          </SelectItem>
                        </SelectContent>
                      </ShadSelect>
                      {submitted && errors.maritalStatus && (
                        <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                          {errors.maritalStatus}
                        </p>
                      )}
                    </div>
                    {(formData.maritalStatus === "Divorced" ||
                      formData.maritalStatus === "Widowed") && (
                      <div className="space-y-2">
                        <Label
                          htmlFor="children"
                          className="text-sm font-semibold text-gray-700"
                        >
                          {t("Children")}
                        </Label>
                        <Input
                          id="children"
                          type="number"
                          placeholder={t("Number of children")}
                          value={formData.child_count || ""}
                          onChange={(e) =>
                            handleFieldChange("child_count", e.target.value)
                          }
                          className={`
        h-10 rounded-l border bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 hover:border-gray-400
        ${
          errors.child_count
            ? "border-red-500 ring-2 ring-red-200"
            : "border-gray-300"
        }
      `}
                          min="0"
                          max="20"
                        />
                         {submitted && errors.child_count && (
                        <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                          {errors.child_count}
                        </p>
                      )}
                      </div>
                    )}
                  </div>

                  <div className="flex justify-center">
                    <Button
                      type="submit"
                       className=" bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                    >
                      {t("Create Account")}
                    </Button>
                  </div>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      <AlertDialog open={!verifiedUser}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {t("Mobile Verification Required")}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {t(
                "Please verify your mobile number to access the registration page."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                navigate("/login");
              }}
            >
              {t("Go to Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
